import React, { Component } from 'react';
import ReactQuill from 'react-quill';
import videojs from 'video.js'
import { connect } from 'react-redux';
import { actionCreators } from './store';
import { message, Rate, Pagination } from 'antd';
import ListLoader from '../../common/listloader';
import NoList from '../../common/nolist';
import 'video.js/dist/video-js.css';
import './style.css';
import abbr from '../../config/abbr';
// import imgNoNote from '../../assets/images/nonote.png'
import Header from '../../common/header';
import Footer from '../../common/footer';
import {setTimeNow} from "./store/actionCreators";

class Video extends Component {


	constructor(props) {
		super(props);
		this.state = ({
			quillModules: {
				toolbar: [
					['bold', 'italic', 'underline', 'strike'],        // toggled buttons
					['blockquote'],

					[{ 'header': 1 }, { 'header': 2 }],               // custom button values
					[{ 'list': 'ordered'}, { 'list': 'bullet' }],
					[{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
					[{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
					[{ 'direction': 'rtl' }],                         // text direction

					[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
					[{ 'header': [1, 2, 3, 4, 5, 6, false] }],

					[{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
					[{ 'font': [] }],
					[{ 'align': [] }],
					['image'],
				],
			}
		})
		this.fbmenu = this.fbmenu.bind(this);
	}

	componentDidMount() {
		this.props.initData(this.props.history);
		this.definePlayer();
		this.validateClassIdAndLogin();
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.videoUrl !== this.props.videoUrl) {
			// this.player.play();
			// this.player.src({type: 'video/mp4', src: 'https://media.w3.org/2010/05/sintel/trailer_hd.mp4'});
			this.player.src(nextProps.videoUrl);
			this.player.currentTime(nextProps.lookTime);
		}
	}
	// destroy player on unmount
	componentWillUnmount() {
		if (this.player) {
			this.player.dispose();
		}
	}

	definePlayer(){
		let self = this;
		this.player = videojs(this.videoNode, {
			suppressNotSupportedError: false,
			notSupportedMessage: '视频请求错误，请联系管理员或刷新重试哦',
			playbackRates: [0.7, 1.0, 1.2, 1.5, 2.0],
			controlBar: {
				fullscreenToggle: true,
				VolumePanel: {
					inline: false
				},
				pictureInPictureToggle: false,
				volumePanel: false,
				currentTimeDisplay: true,
				timeDivider: true,
				durationDisplay: true,
				remainingTimeDisplay: false,
				playbackRateMenuButton: true,
			}
		}, function onPlayerReady() {
			this.on('pause', function(){
				console.log('1');
				self.clearTimeRecordsTop();
			})
			this.on('play', function(){
				console.log('2');
				self.clearTimeRecordsTop();
				self.setTimeRecordsTop();
			})
			this.on('error', function(){
				console.log('3');
				self.clearTimeRecordsTop();
			})
			console.log('获取时间');
			self.props.setTimeNow(self.props.videoId);
		});
	}

	validateClassIdAndLogin(){

		//let id = url.substr(7);
		let url = this.props.history.location.pathname.split('/')[2];
		let classId = url.split('_')[0];
		let gradeId = url.split('_')[1];

		let isLogin = localStorage.getItem('lsisLogin');
		let isSaveFreeVideo = localStorage.getItem('freeVideoArrls');
		let pushArr = [];
		if(!classId){
			this.props.history.push('/');
			return;
		}else{
			if(isLogin){//登录了，给权限
				this.props.getVideoDetail(classId,gradeId);
				return;
			}else{//没有登录，判断是否听了5篇
				if(isSaveFreeVideo){//非第一个
					pushArr = JSON.parse(localStorage.getItem('freeVideoArrls'));
					let freeVideoNumls = parseInt(localStorage.getItem('freeVideoNumls')) + 1;
					if(pushArr.indexOf(classId) === -1){
						if(freeVideoNumls >= 6){
							message.error('请登录后继续观看哦');
							this.props.history.push('/login');
							return;
						}else{
							pushArr.push(classId);
							localStorage.setItem('freeVideoArrls', JSON.stringify(pushArr));
							localStorage.setItem('freeVideoNumls', freeVideoNumls);
							this.props.getVideoDetail(classId,gradeId);
							return;
						}
					}else if(pushArr.indexOf(classId) !== -1 && freeVideoNumls >= 6){
						message.error('请登录后继续观看哦');
						this.props.history.push('/login');
						return;
					}else if(pushArr.indexOf(classId) !== -1){
						this.props.getVideoDetail(classId,gradeId);
						return
					}
				}else{//第一个
					pushArr.push(classId);
					localStorage.setItem('freeVideoArrls', JSON.stringify(pushArr));
					localStorage.setItem('freeVideoNumls', 1);
					this.props.getVideoDetail(classId,gradeId);
				}
			}
		}
	}

	setTimeRecordsTop(){
		let self = this;
		let url = this.props.history.location.pathname.split('/')[2];
		let gradeId = url.split('_')[1];
		self.timeRecords = setInterval(() => {
			if(self.player){
				var lookTime = self.player.currentTime();
				var time = self.props.studyTime + 60;
				self.props.saveVideoRecord(self.props.videoId, lookTime, time,gradeId);
			}
		},60000)
	}

	clearTimeRecordsTop(){
		clearInterval(this.timeRecords);
	}

	fbmenu(e){
		e.preventDefault()
		return false;
	}

	render() {
		const { curTab, videoId, teacherArea,courseDueTime,addCommentContent, rateNum, commentPage, commentTotal, askQuestionTitle, quillValue,
			solvePage, solveTotal, notePage, noteTotal, addNoteContent, changeTab, handleCommentTextareaChange, addComment, handleRateChange, onPageSizeCommentChange, onPageSizeSolveChange,
			handleAskQuestionInputChange, handleQuillChange, submitAsk, playSetVideoTime, isLoaderCommentShow, isLoaderSolveShow, isLoaderNoteShow,
			onPageSizeNoteChange, addNote, handleNoteTextareaChange, handleNoteTextareaFocus } = this.props;
		const ipaddr = abbr.ip;
		const courseInfo = this.props.courseInfo.toJS();
		const teacherInfo = this.props.teacherInfo.toJS();
		const commentList = this.props.commentList.toJS();
		let solveList = [];
		if(this.props.solveList){
			solveList = this.props.solveList.toJS()
		}

		const noteList = this.props.noteList.toJS();
		const self = this;
		let userObj = {
			"stuName": 'default-man'
		};
		if(localStorage.getItem('userObj')){
			userObj = localStorage.getItem('userObj');
		}

		return(
			<div className="lrvideo">
				<Header/>
				<div className="topv" onContextMenu={this.fbmenu}>
					<div className="topin mx1200 mauto">
						<div className="title c_fff size_18">{courseInfo.classTitle}</div>
						<video ref={ node => this.videoNode = node } preload="auto" controls="controls"
							   className="video-js vjs-big-play-centered"></video>
					</div>
				</div>
				<div className="bottomv">
					<div className="bottomin mx1200 mauto clear">
						<div className="left fl">
							<div className="leftin">
								<ul className="tab clear">
									<li className={curTab === 'courseintro' ? 'cur' : ''}
										onClick={ev => changeTab('courseintro')}>
										<div className="text">课程简介</div>
										{/* <div className="num"></div> */}
									</li>
									<li className={curTab === 'comments' ? 'cur' : ''}
										onClick={ev => changeTab('comments')}>
										<div className="text">老师评价</div>
										{/* <div className="num">(7638)</div> */}
									</li>
									<li className={curTab === 'questions' ? 'cur' : ''}
										onClick={ev => changeTab('questions')}>
										<div className="text">名师答疑</div>
										{/* <div className="num">(7638)</div> */}
									</li>
									<li className={curTab === 'coursenotes' ? 'cur' : ''}
										onClick={ev => changeTab('coursenotes')}>
										<div className="text">课程笔记</div>
										{/* <div className="num">(7638)</div> */}
									</li>
								</ul>
								{
									curTab === 'courseintro' ? (
										<div className="part1">
											<div className="item">
												<div className="size_20 font_m m18b">我的课程：</div>
												<div className="size_20 font_m m18b">{courseInfo.classTitle}</div>
												<div className="size_16">主讲：{teacherInfo.tchName}&nbsp;&nbsp;&nbsp;&nbsp;年份：{courseInfo.classYear}年{/* &nbsp;&nbsp;&nbsp;&nbsp;到期时间：{courseDueTime} */}</div>
											</div>
											{/* <div className="item serv">
												<div className="size_20 font_m m18b">我的服务：</div>
												<div className="clear">
													<div className="itemin">
														<span className="bg"></span><span className="text">课后习题</span>
													</div>
													<div className="itemin">
														<span className="bg"></span><span className="text">在线题库</span>
													</div>
													<div className="itemin">
														<span className="bg"></span><span className="text">移动课堂</span>
													</div>
													<div className="itemin">
														<span className="bg"></span><span className="text">名师答疑</span>
													</div>
													<div className="itemin">
														<span className="bg"></span><span className="text">班主任定制</span>
													</div>
													<div className="itemin">
														<span className="bg"></span><span className="text">讲义下载</span>
													</div>
													<div className="itemin">
														<span className="bg"></span><span className="text">视频下载</span>
													</div>
													<div className="itemin">
														<span className="bg"></span><span className="text">直播服务</span>
													</div>
												</div>
											</div> */}
											<div className="item">
												<div className="size_20 font_m m18b">主讲内容：</div>
												<div className="size_16 font_m lineht24">{teacherInfo.introduce}</div>
											</div>
											{/* <div className="item">
												<div className="size_20 font_m m18b">适用人群：</div>
												<div className="size_20 font_m">二级建造师考试所有考生</div>
											</div> */}
										</div>
									) : (
										curTab === 'comments' ? (
											<div className="part2">
												<div className="subcom">
													<div className="size_20 font_m m10b">主讲老师：{teacherInfo.tchName}</div>
													<div className="size_36 font_b m20b c_redff2626 textc">教学好评&nbsp;&nbsp;{teacherInfo.percent}</div>
													<div className="star m30b">
														<Rate onChange={ev => handleRateChange(ev)} value={rateNum}/>
													</div>
													<textarea placeholder="选填...感谢您的真实评价，我们会努力做到更好" value={addCommentContent ? addCommentContent : ''}
															  onChange={ev => handleCommentTextareaChange(ev)} name="" id="" cols="30" rows="10"></textarea>
													<div className="textc m30t"><span className="subcm" onClick={ev => addComment(addCommentContent, rateNum, teacherInfo.tchId)}>提交评价</span></div>
												</div>
												<div className="infoitemlr">
													{isLoaderCommentShow ? <ListLoader className="p20v"/> : (
														commentList.length !== 0 ? (
															<div>
																{commentList.map(function(item, index){
																	return(
																		<div className="item clear" key={index}>
																			<div className="imginfo fl">
																				<img src={ipaddr+item.student.stuImgUrl} alt=""/>
																				<div className="name">{item.student.stuUsernam}</div>
																			</div>
																			<div className="info fr">
																				<div className="size_16 lineht24">{item.commentContent}</div>
																				<div className="size_16 c_666 m18t">{item.commentAddTime.split('T')[0]}&nbsp;{item.commentAddTime.split('T')[1]}</div>
																			</div>
																		</div>
																	)
																})}
																<div className="textc p20v bg_fff">
																	<Pagination defaultCurrent={commentPage} total={commentTotal} pageSize={10} onChange={ev => onPageSizeCommentChange(ev, teacherInfo.tchId)} />
																</div>
															</div>
														) : (
															<div className="p20v"><NoList/></div>
														)
													)}
												</div>
											</div>
										) : (
											curTab === 'questions' ? (
												<div className="part3">
													{isLoaderSolveShow ? (
														<div className="p20v"><ListLoader /></div>
													) : (
														solveList.length !== 0 ? (
															<div>
																{solveList.map(function(item, index){
																	return(
																		<div className="item" key={index}>
																			<div className="itemin">
																				<div className="wen clear">
																					<div className="imginfo fl">
																						<img src="@img/default.jpg" alt=""/>
																						<div className="name">{userObj.stuName}</div>
																					</div>
																					<div className="info fr">
																						<div className="lineht24 size_16" v-html="item.questionTitle">{item.questionTitle}</div>
																						<div className="m8t c_666 size_16">{item.questionAddTime.split('T')[0]}&nbsp;{item.questionAddTime.split('T')[1]}</div>
																					</div>
																				</div>
																				<div className="da">
																					<div className="lineht24 size_16" dangerouslySetInnerHTML={{__html:item.answerContent}} />
																					{/* <div className="m8t c_666 size_16">2019/04/03 18:09</div> */}
																				</div>
																			</div>
																		</div>
																	)
																})}
																<div className="textc p20v bg_fff">
																	<Pagination defaultCurrent={solvePage} total={solveTotal} pageSize={10} onChange={ev => onPageSizeSolveChange(ev, videoId)} />
																</div>
															</div>
														) : (
															<div className="p20v">
																<div className="c_blue size_26 lineht36 textc">此课程您还没有提问<br/>或者<br/>你的问题老师暂时还没有回复哦！<br/>可在下方表单处提问</div>
															</div>
														)
													)}
													<div className="lrask">
														<div className="top">
															<input className="wp100" maxLength="50" placeholder="请输入您要提的问题" value={askQuestionTitle} onChange={ev => handleAskQuestionInputChange(ev)}/>
														</div>
														<div className="down">
															<ReactQuill value={quillValue} theme="snow" modules={this.state.quillModules}
																		placeholder="请输入您的问题描述..."
																		onChange={ev => handleQuillChange(ev)}></ReactQuill>
															<div className="textc">
																<span className="bluebtn dislb m24t" onClick={ev => submitAsk(askQuestionTitle, quillValue, videoId)}>提交</span>
															</div>
														</div>
													</div>
												</div>
											) : (
												curTab === 'coursenotes' ? (
													<div className="part4">
														<div className="noteask">
															<div>
													<textarea placeholder="好记性不如烂笔头" name="" id="" ref="notetextarea" value={addNoteContent} rows="10" onFocus={ev => handleNoteTextareaFocus(this.player)}
															  onChange={ev => handleNoteTextareaChange(ev)}></textarea>
															</div>
															<span className="bluebtn dislb" onClick={ev => addNote(addNoteContent, videoId, this.player)}>标为难点</span>
														</div>
														{isLoaderNoteShow ? (
															<div className="p20v"><ListLoader /></div>
														) : (
															noteList.length !== 0 ? (
																<div>
																	{noteList.map(function(item, index){
																		return(
																			<div className="item clear" key={index}>
																				<div className="imginfo fl">
																					<img src="@img/default.jpg" alt=""/>
																					<div className="name">{userObj.stuName}</div>
																				</div>
																				<div className="info fl">
																					<div className="infoin size_16 c_666">
																						{/* <div><span className="m16r">4-1030建设工程代理制度2</span><span>“item.noteVideotime”</span></div> */}
																						<div className="c_333 m12b lineht24">{item.noteContent}</div>
																						<div>{item.noteAddTime.split('T')[0]}&nbsp;{item.noteAddTime.split('T')[1]}</div>
																					</div>
																				</div>
																				<span className="fl playnoteimg" onClick={ev => playSetVideoTime(self.player, item.noteVideotime)}></span>
																			</div>
																		)
																	})}
																	<div className="textc p20v bg_fff">
																		<Pagination defaultCurrent={notePage} total={noteTotal} pageSize={10} onChange={ev => onPageSizeNoteChange(ev, videoId)} />
																	</div>
																</div>
															) : null
														)}
													</div>
												) : null
											)
										)
									)
								}
							</div>
						</div>
						<div className="right fl">
							<div className="rightin">
								<div className="up">
									<div className="upin">
										<div className="bigtitle">师资介绍</div>
										<div className="part">
											<div className="item intro">
												<div className="size_20 font_m m9b">主讲老师：{teacherInfo.tchName}</div>
												<div className="size_24 font_b c_redff2626 m18b">教学好评&nbsp;&nbsp;{teacherInfo.percent}</div>
												<div className="size_16 c_666 lineht24">{teacherInfo.tchDescription}</div>
											</div>
											<div className="item area">
												<div className="size_20 font_m m20b">主讲领域：</div>
												<div className="label clear">
													{teacherArea.map(function(item, index){
														return (
															<span key={index}>{item}</span>
														)
													})}

												</div>
											</div>
										</div>
									</div>
								</div>
								{/* <div className="down">
									<div className="downin">
										<div className="bigtitle">
											相关课程
											<router-link className="more fr" to="/class">
												<span className="tag">查看更多</span>
												<img src="@img/more.png" alt="更多">
											</router-link>
										</div>
										<div className="part">
											<div className="item clear">
												<img className="fl" src="@img/default.jpg" alt="">
												<div className="fr info">
													<div className="title font_m">2020二级建造师取证班</div>
													<div className="label c_666 lineht24">
														名师教学，免费重学，班主任定制服务
													</div>
													<div className="size_12 c_666">3456人已报名</div>
													<a href={hrefUrl} className="go">去试听</a>
												</div>
											</div>
											<div className="item clear">
												<img className="fl" src="@img/default.jpg" alt="">
												<div className="fr info">
													<div className="title font_m">2020二级建造师取证班</div>
													<div className="label c_666 lineht24">
														名师教学，免费重学，班主任定制服务
													</div>
													<div className="size_12 c_666">3456人已报名</div>
													<a href={hrefUrl} className="go">去试听</a>
												</div>
											</div>
										</div>
									</div>
								</div> */}
							</div>
						</div>
					</div>
				</div>
				<Footer/>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		videoId: state.getIn(['video', 'videoId']),
		videoUrl: state.getIn(['video', 'videoUrl']),
		studyTime: state.getIn(['video', 'studyTime']),
		lookTime: state.getIn(['video', 'lookTime']),
		lastCreateTime: state.getIn(['video', 'lastCreateTime']),
		lastStudyTime: state.getIn(['video', 'lastStudyTime']),
		courseInfo: state.getIn(['video', 'courseInfo']),
		teacherInfo: state.getIn(['video', 'teacherInfo']),
		curTab: state.getIn(['video', 'curTab']),
		teacherArea: state.getIn(['video', 'teacherArea']),
		commentList: state.getIn(['video', 'commentList']),
		courseDueTime: state.getIn(['video', 'courseDueTime']),
		addCommentContent: state.getIn(['video', 'addCommentContent']),
		rateNum: state.getIn(['video', 'rateNum']),
		commentPage: state.getIn(['video', 'commentPage']),
		commentTotal: state.getIn(['video', 'commentTotal']),
		askQuestionTitle: state.getIn(['video', 'askQuestionTitle']),
		solvePage: state.getIn(['video', 'solvePage']),
		solveTotal: state.getIn(['video', 'solveTotal']),
		quillValue: state.getIn(['video', 'quillValue']),
		solveList: state.getIn(['video', 'solveList']),
		noteList: state.getIn(['video', 'noteList']),
		notePage: state.getIn(['video', 'notePage']),
		noteTotal: state.getIn(['video', 'noteTotal']),
		addNoteContent: state.getIn(['video', 'addNoteContent']),
		isLoaderCommentShow: state.getIn(['video', 'isLoaderCommentShow']),
		isLoaderSolveShow: state.getIn(['video', 'isLoaderSolveShow']),
		isLoaderNoteShow: state.getIn(['video', 'isLoaderNoteShow']),
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		initData(history){
			let url = history.location.pathname;
			//let id = url.substr(7);
			let id = url.split('/')[2];
			let classId = id.split('_')[0];

			dispatch(actionCreators.setVideoId(classId));
		},
		getVideoDetail(id,gradeId){
			dispatch(actionCreators.getVideoDetail(id,gradeId));
		},
		changeTab(tab) {
			dispatch(actionCreators.changeTab(tab))
		},
		handleCommentTextareaChange(e){
			let val = e.target.value;
			dispatch(actionCreators.handleCommentTextareaChange(val));
		},
		addComment(comment, rate, tchId){
			let lsisLogin = localStorage.getItem('lsisLogin');
			if(!lsisLogin){
				message.error('请先登录！');
				return false;
			}
			if(comment === ''){
				message.warning('你还没有输入评价内容哦！');
				return false;
			}
			if(!rate){
				message.warning('你还没有选择评价星级哦！');
				return false;
			}
			dispatch(actionCreators.addComment(comment, rate, tchId))
		},
		handleRateChange(val){
			dispatch(actionCreators.handleRateChange(val));
		},
		onPageSizeCommentChange(page, id){
			dispatch(actionCreators.setCommentPage(page));
			dispatch(actionCreators.setCommentLoader(true));
			dispatch(actionCreators.setCommentListByPage(page, id));
		},
		onPageSizeSolveChange(page, id){
			dispatch(actionCreators.setSolvePage(page));
			dispatch(actionCreators.setSolveLoader(true));
			dispatch(actionCreators.setSolveListByPage(page, id));
		},
		handleQuillChange(val){
			dispatch(actionCreators.handleQuillChange(val));
		},
		handleAskQuestionInputChange(e){
			let val = e.target.value;
			dispatch(actionCreators.handleAskQuestionInputChange(val));
		},
		submitAsk(title, desc, id, gid, eid){
			let lsisLogin = localStorage.getItem('lsisLogin');
			if(!lsisLogin){
				message.error('请先登录！');
				return false;
			}
			if(title === ''){
				message.warning('问题标题必填哦！');
				return;
			}
			if(desc === ''){
				message.warning('问题描述必填哦！');
				return;
			}
			dispatch(actionCreators.submitAsk(title, desc, id, gid, eid));
		},
		playSetVideoTime(player, time){
			window.scrollTo(0, 0);
			player.currentTime(time);
			player.play();
		},
		onPageSizeNoteChange(page, id){
			dispatch(actionCreators.setNotePage(page));
			dispatch(actionCreators.setNoteLoader(true));
			dispatch(actionCreators.getNoteList(page, 10, id));
		},
		handleNoteTextareaChange(e){
			let val = e.target.value;
			dispatch(actionCreators.handleNoteTextareaChange(val));
		},
		handleNoteTextareaFocus(player){
			player.pause();
		},
		addNote(desc, id, player){
			let lsisLogin = localStorage.getItem('lsisLogin');
			if(!lsisLogin){
				message.error('请先登录！');
				return false;
			}
			if(desc === ''){
				message.warning('笔记内容必填哦！');
				return;
			}
			var time = player.currentTime();
			dispatch(actionCreators.addNote(desc, id, time));
		},
		saveVideoRecord(classId, lookTime, studyTime,gradeId){
			//lastCreateTime,lastStudyTime,
			dispatch(actionCreators.saveVideoRecord(classId, lookTime, studyTime,gradeId));
		},
		setTimeNow(id){
			dispatch(actionCreators.setTimeNow(id));
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Video);
